import React, { Fragment, useState } from "react";

import { SearchspringFacet } from "@app/types";

import { useSearchspringSearchContext } from "@app/providers/searchspring";
import { useSearchspringFilters } from "@app/hooks/use-searchspring-filters";

import { Icon } from "@app/components/icon";
import { ResultFilter } from "@app/components/result-filter";
import { ResultSort } from "@app/components/result-sort";
import { ResultActiveFilter } from "@app/components/result-active-filters";

export function ResultFilterDrawer() {
  const { response, refine } = useSearchspringSearchContext();

  const { activeFilters, handleToggleFilter } = useSearchspringFilters();

  const [initialFilters, setInitialFilters] = useState<SearchspringFacet[]>([]);
  const [restorableFilters, setRestorableFilters] = useState<Set<string>>();

  const handleOpenFilters = () => {
    if (!response) return;
    if (initialFilters.length === 0) setInitialFilters(response.facets);
  };

  const handleCancelFilters = () => {
    if (!restorableFilters) return;
    refine("filters", restorableFilters);
    setRestorableFilters(undefined);
  };

  if (!response) return;

  return (
    <div x-data="modal">
      <button className="btn btn-md btn-outline-light" x-bind="toggle" onClick={handleOpenFilters}>
        <Icon className="size-5" id="Filter" />
        <span className="md:hidden">Filter & Sort</span>
        <span className="max-md:hidden">Filters</span>
      </button>
      <div x-bind="portal" x-cloak>
        <div className="anchor-bottom md:anchor-left flex h-full flex-col justify-between gap-6 bg-neutrals-white px-4 py-8 md:w-full md:max-w-136 md:p-8">
          <div className="flex flex-col gap-6 overflow-hidden">
            <div className="flex items-center justify-between">
              <h4>Filters</h4>
              <button x-bind="close" className="btn btn-icon btn-sm btn-outline-light btn-square">
                <Icon className="size-4" id="Cross" />
              </button>
            </div>
            <div className="no-scrollbar flex h-full flex-col gap-6 overflow-y-scroll" x-bind="content">
              <div className="md:hidden">
                <ResultSort />
              </div>
              <hr className="border-neutrals-grey-4" />
              <ResultActiveFilter />
              {initialFilters.map((filter) => {
                if (filter.label == "Price") return null;
                return (
                  <Fragment key={filter.field}>
                    <ResultFilter
                      filter={filter}
                      onFilter={handleToggleFilter}
                      fetchedFilters={response.facets}
                      activeFilters={activeFilters}
                    />
                    <hr className="border-neutrals-grey-4" />
                  </Fragment>
                );
              })}
            </div>
          </div>
          <div className="flex gap-4">
            <button className="btn btn-md btn-outline-light grow justify-center" onClick={handleCancelFilters}>
              Cancel
            </button>
            <button className="btn btn-md btn-solid-light grow justify-center" x-bind="close">
              Show results ({response.pagination.totalResults})
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
